const getValue = (key, def = false) => {
  const context = window.features;
  if (!context) return def;

  return context[key] !== undefined ? context[key] : def;
};

export const getFeature = getValue;
export const featureEnabled = getValue;
